export default "__VITE_ASSET__GAm49kaL__"